import {Observable, Subject} from 'rxjs';
import {take} from 'rxjs/operators';

export default class PopupService {
    private localOpenedPopups: { [name: string]: OpenedPopup } = {};
    private static instance: PopupService;
    private lastActionDate: number = 0;

    private constructor() {
    }

    public static getInstance(): PopupService {
        if (!PopupService.instance) {
            PopupService.instance = new PopupService();
        }
        return PopupService.instance;
    }

    public open(name: string, params: { [key: string]: any } = {}): Observable<any> {
        if (!this.localOpenedPopups[name]) {
            this.localOpenedPopups[name] = {opened: false, params: {}, subject: new Subject()};
        }
        this.localOpenedPopups[name].opened = true;
        this.localOpenedPopups[name].params = params;
        this.lastActionDate = new Date().getTime();
        return this.localOpenedPopups[name].subject.pipe(take(1));
    }

    public params(name: string): { [key: string]: any } {
        return this.localOpenedPopups[name] ? this.localOpenedPopups[name].params : {};
    }

    public close(name: string, data: any = null): void {
        if (this.localOpenedPopups[name]) {
            this.localOpenedPopups[name].subject.next(data);
            this.localOpenedPopups[name].opened = false;
            this.lastActionDate = new Date().getTime();
        }
    }

    public isOpened(name: string): boolean {
        return (this.lastActionDate > 0 && this.localOpenedPopups[name] && this.localOpenedPopups[name].opened) || false;
    }
}

interface OpenedPopup {
    opened: boolean,
    params: { [key: string]: any },
    subject: Subject<any>,
}
